export const basePathAPIServer = "https://api.b2beak.com/api/";

export const MANAGER = "manager";
export const OPERATOR = "operator"; 

/** LOCAL STORAGE */
export const keyEndpoint = "https://api.b2beak.com/";
export const keySourceScreen = "source_screen";

export const keyStatusLogin = "status_login";
export const isSigned = false;
export const keyProfileIsComplete = "profile_status";
export const valueProfileIsComplete = false;

/** Username Logged */
export const keyUserLoggedInAs = "user_logged_in_as";
export const keyIdUserLogged = "id_user_logged";
export const valueIdUserLogged = 0;
export const keyUsernameLogged = "username_logged";
export const valueUsernameLogged = "";
export const keyIdTypeUserLogged = "id_type_user_logged";
export const valueIdTypeUserLogged = 0;
export const keyTypeUserLogged = "type_user_logged";
export const valueTypeUserLogged = "";
export const keyPictureUserLogged = "picture_user_logged";
export const valuePictureUserLogged = "";
export const keyIdRole = "id_role";
export const valueIdRole = 0;
export const keyRole = "role";
export const valueRole = "";

/** Manager */
export const keyIdUserManager = "id_user_manager";
export const valueIdUserManager = 0;
export const keyUsernameManager = "username_manager";
export const valueUsernameManager = "";
export const keyIdTypeUserManager = "id_type_user_manager";
export const valueIdTypeUserManager = 2; // DOING: viene impostato qui di default ma deve essere sovrascritto da quello che arriva dal server
export const keyPictureManager = "picture_manager";
export const valuePictureUserManager = "";

/** Permissions */
export const keyIdPermission = "id_permission";
export const valueIdPermission = 0;
export const keyPriorityPermission = "priority_permission";
export const valuePriorityPermission = 99;

/** Dates */
export const keyRegistrationData = "registration_data";
export const valueRegistrationData = "";
export const keyTrialPeriodExpirationData = "trial_period_expiration_data";
export const valueTrialPeriodExpirationData = "";
export const keyStatusTrialPeriod = "status_trial_period"; // expired | in_progress
export const valueStatusTrialPeriod = "";

/** Company */
export const keyIdCompany = "id_company";
export const valueIdCompany = 0;
export const keyCompanyName = "company_name";
export const valueCompanyName = "";
export const keyCompanyPicture = "company_picture";
export const valueCompanyPicture = "";

/** Store */
export const keyIdStore = "id_store";
export const valueIdStore = 0;
export const keyStoreName = "store_name";
export const valueStoreName = "";

/** Warehouse */
export const keyIdWarehouse = "id_warehouse";
export const valueIdWarehouse = 0;

export const keyIdStoreCart = "id_store_cart";
export const valueIdStoreCart = 0;

export const keyLastIdRecipient = "last_id_recipient";
export const valueLastIdRecipient = "";

export const keyNewsUpdate = "news_update";
export const valueNewsUpdate = "";

export const keyTypeNumericInput = "type_numeric_input";
export const valueTypeNumericInput = false;

/** Features */
export const keyPremiumFeatureWarehouse = "premium_feature_warehouse";
export const valuePremiumFeatureWarehouse = false;
